$("body").on("click", ".Help-trigger_mobile", function (event) {
$('.ProductRedesign_Popup').show();
$('.popup_overlay').show();
$('.pick_currency').hide();
});
$("body").on("click", ".Help-trigger_close_mobile", function (event) {
$('.ProductRedesign_Popup').hide();
$('.popup_overlay').hide();
$('.pick_currency').show(); 
});
$("body").on("click", ".ProductRedesign_quantity_selector", function (event) {
    var variant_id = $(this).attr('data-attr');
    var variant_id_enabled_tmg = $(this).attr('data-attr-checked');
    var price_identifier = $(this).attr('data-name');
  if($(this).hasClass('enabled_tmg')) {
  $('.ProductRedesign_ATC_trigger').attr('href', variant_id_enabled_tmg);
  }
  else {
  $('.ProductRedesign_ATC_trigger').attr('href', variant_id);
  }
   
   $( ".ProductRedesign_quantity_selector" ).each(function() {
  $(this).removeClass('ProductRedesign_active_selector');
	});
  $(this).addClass('ProductRedesign_active_selector');
  $( ".all_prices" ).each(function() {
     $(this).removeClass('active_product_price');
    if($(this).hasClass(price_identifier)){
    $(this).addClass('active_product_price ');
    }
	});
  
  
});
  
$(".Add_tmg_to_order").change(function() {
    if(this.checked) {
      $('.MixedProduct').css('display', 'flex');
      $('.SingleProduct').hide();
      $( ".ProductRedesign_quantity_selector" ).each(function() {
        $(this).addClass('enabled_tmg');
        if($(this).hasClass('ProductRedesign_active_selector')){
        var current_permalink = $(this).attr('data-attr-checked');
          console.log(current_permalink);
          $('.ProductRedesign_ATC_trigger').attr('href', current_permalink);
        }
	});
    }else{
     $('.MixedProduct').hide();
      $('.SingleProduct').css('display', 'flex');
      $( ".ProductRedesign_quantity_selector" ).each(function() {
        $(this).removeClass('enabled_tmg');
        if($(this).hasClass('ProductRedesign_active_selector')){
        var current_permalink = $(this).attr('data-attr');
          console.log(current_permalink);
          $('.ProductRedesign_ATC_trigger').attr('href', current_permalink);
        }
	});
      
    }
});


$( document ).ready(function() {
//    $('.ProductRedesign_active_selector ').click();
  
});


  function open_product_tmg() {
  console.log('clicked tmg');
    $('.tmg_switch').addClass('active__switch-selector');
    $('.nmn_250_switch').removeClass('active__switch-selector');
    $('.nmn_500_switch').removeClass('active__switch-selector');
    $('.landing-collection').addClass('active-collection');
    $('#whole-product-tmg').addClass('active_product');
    $('#whole-product-nmn-250').removeClass('active_product');
    $('#landing_nmn_500').removeClass('active_product');
    $('html, body').animate({
                    scrollTop: $("#whole-product-tmg").offset().top
                }, 1000);
  }
  
  function open_product_nmn_250(){
  console.log('clicked nmn 250');
    $('.tmg_switch').removeClass('active__switch-selector');
    $('.nmn_250_switch').addClass('active__switch-selector');
    $('.nmn_500_switch').removeClass('active__switch-selector');
    $('.landing-collection').addClass('active-collection');
    $('#whole-product-nmn-250').addClass('active_product');
     $('#whole-product-tmg').removeClass('active_product');
    $('#landing_nmn_500').removeClass('active_product');
    $('html, body').animate({
                    scrollTop: $("#whole-product-nmn-250").offset().top
                }, 1000);
  }
  
  function open_product_nmn_500(){
  console.log('clicked nmn 500');
    $('.tmg_switch').removeClass('active__switch-selector');
    $('.nmn_250_switch').removeClass('active__switch-selector');
    $('.nmn_500_switch').addClass('active__switch-selector');
    $('.landing-collection').addClass('active-collection');
    $('#landing_nmn_500').addClass('active_product');
    $('#whole-product-nmn-250').removeClass('active_product');  
    $('#whole-product-tmg').removeClass('active_product');
      $('html, body').animate({
                    scrollTop: $("#landing_nmn_500").offset().top
                }, 1000);
  }
//    END of Swith
$( document ).ready(function() {
  
//   $( ".onetime-selector" ).click(function() {
//   var variant_original_price = $(this).parent('.paywhirl-plan-selector-group').attr('price');
//     variant_original_price = parseFloat(variant_original_price).toFixed(2);
//   var one_time_price_value = $(this).parent('.paywhirl-plan-selector-group').attr('currency');
//   var section_id = $(this).parent('.paywhirl-plan-selector-group').attr('section_id');

    
//     var per_pill_original_1 = $('.bottle_quantity_one').attr('original_price_per_pill');
//     var per_pill_original_3 = $('.bottle_quantity_three').attr('original_price_per_pill');
//     var per_pill_original_6 = $('.bottle_quantity_six').attr('original_price_per_pill');
    

//     if (one_time_price_value.indexOf('$') >= 0) {
// //       $('.quantity_three').html('$' + pricePerPill_three + ' per pill');
// //       $('.quantity_six').html('$' + pricePerPill_six + ' per pill');
// //       $('.quantity_one').html('$' + pricePerPill_one + ' per pill');
//        if ( section_id == 'Three'){
//     $('.original_price_for_autodelivery_js_three').html('$' + variant_original_price);
//     $('.quantity_three').html(per_pill_original_3 + ' per pill');
//      }
//        if ( section_id == 'Six'){
//     $('.original_price_for_autodelivery_js_six').html('$' + variant_original_price);
//     $('.quantity_six').html(per_pill_original_6 + ' per pill');
//        }
//        if ( section_id == 'One'){
//      $('.original_price_for_autodelivery_js_one').html('$' + variant_original_price);
//      $('.quantity_one').html(per_pill_original_1 + ' per pill');
//        }
//     }
//      if (one_time_price_value.indexOf('£') >= 0) {
// //       $('.quantity_three').html('$' + pricePerPill_three + ' per pill');
// //       $('.quantity_six').html('$' + pricePerPill_six + ' per pill');
// //       $('.quantity_one').html('$' + pricePerPill_one + ' per pill');
//        if ( section_id == 'Three'){
//     $('.original_price_for_autodelivery_js_three').html('£' + variant_original_price);
//      }
//        if ( section_id == 'Six'){
//     $('.original_price_for_autodelivery_js_six').html('£' + variant_original_price);
//        }
//        if ( section_id == 'One'){
//      $('.original_price_for_autodelivery_js_one').html('£' + variant_original_price);
//        }
//     }
    
//   });
   
                                 
  $( ".click_to_select_subs" ).click(function() {
    
    var per_pill_original_1 = $('.bottle_quantity_one').attr('price_per_pill');
    var per_pill_original_3 = $('.bottle_quantity_three').attr('price_per_pill');
    var per_pill_original_6 = $('.bottle_quantity_six').attr('price_per_pill');
    
    per_pill_original_1 = (parseFloat(per_pill_original_1)*0.9).toFixed(2);
    per_pill_original_3 = (parseFloat(per_pill_original_3)*0.9).toFixed(2);
    per_pill_original_6 = (parseFloat(per_pill_original_6)*0.9).toFixed(2);
    
  var variant_original_price = $(this).parent('.paywhirl-plan-selector-group').attr('price');
  var one_time_price_value = $(this).parent('.paywhirl-plan-selector-group').attr('currency');
  var section_id = $(this).parent('.paywhirl-plan-selector-group').attr('section_id');
  var original_price = variant_original_price;
  $('.to-hide-on-onetime').show();
  $('.to-hide-on-subs').hide(); 
  var selling_plan_name = $(this).find('.autodeliver_plan').attr('value');
  var discount_percent = selling_plan_name.match(/\d+/);
  var new_price = (original_price * (1 - (discount_percent / 100))).toFixed(2); 
//   var one_time_price_value = $('.original_price_for_autodelivery_js').attr('price_currency'); 
     if (one_time_price_value.indexOf('$') >= 0) {
//       $('.quantity_three').html('$' + pricePerPill_three + ' per pill');
//       $('.quantity_six').html('$' + pricePerPill_six + ' per pill');
//       $('.quantity_one').html('$' + pricePerPill_one + ' per pill');
       if ( section_id == 'Three'){
    $('.original_price_for_autodelivery_js_three').html('$' + new_price);
    $('.quantity_three').html('$' + per_pill_original_3 + ' per pill');
     }
       if ( section_id == 'Six'){
    $('.original_price_for_autodelivery_js_six').html('$' + new_price);
    $('.quantity_six').html('$' + per_pill_original_6 + ' per pill');
       }
       if ( section_id == 'One'){
     $('.original_price_for_autodelivery_js_one').html('$' + new_price);
     $('.quantity_one').html('$' + per_pill_original_1 + ' per pill');
       }
    }
     if (one_time_price_value.indexOf('£') >= 0) {
//       $('.quantity_three').html('$' + pricePerPill_three + ' per pill');
//       $('.quantity_six').html('$' + pricePerPill_six + ' per pill');
//       $('.quantity_one').html('$' + pricePerPill_one + ' per pill');
       if ( section_id == 'Three'){
    $('.original_price_for_autodelivery_js_three').html('£' + new_price);
    $('.quantity_three').html('£' + per_pill_original_3 + ' per pill');
     }
       if ( section_id == 'Six'){
    $('.original_price_for_autodelivery_js_six').html('£' + new_price);
    $('.quantity_six').html('£' + per_pill_original_6 + ' per pill');
       }
       if ( section_id == 'One'){
     $('.original_price_for_autodelivery_js_one').html('£' + new_price);
     $('.quantity_one').html('£' + per_pill_original_1 + ' per pill');
       }
    }
     

  });
  
//   
  
  $('.landing-collection').addClass('active-collection');
//   
  if ($(window).width() < 600) {
      $('.landing_offer_section__Whole').addClass('landing_slick_carousel');
   }
  
  $(".section-button").click(function() {
  $('html, body').animate({
    scrollTop: $(".full-offer-section").offset().top
  }, 2000)
});
  
  $( ".trigger_mouse_on_popup" ).mouseover(function() {
  $( ".ProductRedesign_Popup" ).show();
});
  $( ".trigger_mouse_on_popup" ).mouseout(function() {
  $( ".ProductRedesign_Popup" ).hide();
});
  
  
  $('.ProductRedesign_Images_Slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  slickGoTo: 1
  });
  $('.ProductRedesign_Images_Slider').slick('slickGoTo', 1);
  
    $(".video-flex-mobile").slick({
    centerMode: true,
    infinite: false,
    variableWidth: true,
  });
  
  $('.landing_slick_carousel').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
  centerPadding: '60px'
  }                                                                                                       
);
  
  $('.carousel_product_selector').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    dots: true
  }                                       
);
  
  
  $('.slick_carousel_featured').slick({
  infinite: true,
  slidesToShow:4,
  slidesToScroll: 1,
    dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '60px',
        dots: false,
        arrows: false

      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  } );
 
  
  
   $(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});
  
  
 $(".scroll_to").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".product-section").offset().top
    }, 2000);
});
  
  $('.close_popup').click(function() {
  	$('.overlay').hide();
  	$('.video-popup').hide();
    
   
    var v = document.getElementById('videoPlayer');
    v.pause();
       
    
 });
  $('.open_popup').click(function() {
  	$('.overlay').show();
  	$('.video-popup').show();
  });
  
});

document.addEventListener('DOMContentLoaded', function() {
  var aboutUsLink = document.querySelector('a[href="https://nmnbio.co.uk/#quiz-section"]');

  if (aboutUsLink) {
    aboutUsLink.addEventListener('click', function() {
      var drawerCloseButton = document.querySelector('.drawer__close-button');
      if (drawerCloseButton) {
        drawerCloseButton.click();
      }
    });
  }

  // Product Info Tabs Functionality
  var tabHeaders = document.querySelectorAll('.product-info-tab .tab-header');
  
  tabHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var tab = this.parentElement;
      var content = tab.querySelector('.tab-content');
      var icon = tab.querySelector('.tab-icon');
      
      // Toggle active state
      var isActive = tab.classList.contains('active');
      
      if (isActive) {
        // Close the tab
        tab.classList.remove('active');
        content.classList.remove('active');
        icon.textContent = '+';
      } else {
        // Close other tabs first (optional - remove if you want multiple tabs open)
        var allTabs = document.querySelectorAll('.product-info-tab');
        allTabs.forEach(function(otherTab) {
          if (otherTab !== tab) {
            otherTab.classList.remove('active');
            otherTab.querySelector('.tab-content').classList.remove('active');
            otherTab.querySelector('.tab-icon').textContent = '+';
          }
        });
        
        // Open this tab
        tab.classList.add('active');
        content.classList.add('active');
        icon.textContent = '−';
      }
    });
  });




  
  // Sticky Add to Cart Bar - Mobile Only
  function initStickyAddToCartBar() {
    // Only run on mobile
    if (window.innerWidth > 768) return;

    var productForm = document.querySelector('.product-single__form');
    var addToCartButton = productForm ? productForm.querySelector('.add-to-cart') : null;
    var stickyBar = document.querySelector('.sticky-add-to-cart-bar');
    
    if (!productForm || !addToCartButton || !stickyBar) return;

    var stickyBarButton = stickyBar.querySelector('.sticky-add-to-cart-bar__button');
    var stickyBarPrice = stickyBar.querySelector('.sticky-add-to-cart-bar__price');
    var stickyBarVariantDescription = stickyBar.querySelector('.sticky-add-to-cart-bar__variant-description');
    var stickyBarPlanText = stickyBar.querySelector('.sticky-bar-plan-text');
    var stickyBarChangeLink = stickyBar.querySelector('.sticky-bar-change-link');
    var mainButtonText = document.querySelector('[id^="AddToCartText-"]');
    var masterSelect = productForm.querySelector('select.master_select');
    
    // Store the original position of the button
    var originalPosition = null;
    var isBarVisible = false;
    
    // Function to get original position
    function getOriginalPosition() {
      var rect = addToCartButton.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      return {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop
      };
    }

    // Function to check if original button position is visible
    function isOriginalPositionVisible() {
      if (!originalPosition) {
        originalPosition = getOriginalPosition();
      }
      
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      
      // Button is visible if any part of it is in the current viewport
      var buttonTop = originalPosition.top;
      var buttonBottom = originalPosition.bottom;
      var viewportTop = scrollTop;
      var viewportBottom = scrollTop + windowHeight;
      
      // Check if button is in viewport (with some buffer)
      var isVisible = buttonBottom > viewportTop && buttonTop < viewportBottom;
      
      return isVisible;
    }

    // Function to detect current plan type
    // function getCurrentPlanType() {
    //   // Check if Loop widget exists and has a selected plan
    //   if (window.loopProps && Object.keys(window.loopProps).length > 0) {
    //     var productId = Object.keys(window.loopProps)[0];
    //     var loopData = window.loopProps[productId];
        
    //              if (loopData && loopData.sellingPlan ) {
    //        // It's a subscription - get the plan name
    //        var planName = loopData.sellingPlanGroupName || 'Subscription';
    //        // Remove | and everything after it
    //        if (planName.includes('|')) {
    //          planName = planName.split('|')[0].trim();
    //        }
    //        // Rename loop-one-time-purchase to One-time Purchase
    //        if (planName === 'loop-one-time-purchase') {
    //          planName = 'One-time Purchase';
    //        }
    //        return planName;
    //      }
    //   }
      
    //   // Check for other subscription indicators in the DOM
    //   var subscriptionSelectors = document.querySelectorAll('[data-subscription], .subscription-option, .loop-subscription');
    //   for (var i = 0; i < subscriptionSelectors.length; i++) {
    //     var element = subscriptionSelectors[i];
    //     if (element.checked || element.classList.contains('selected') || element.classList.contains('active')) {
    //       var planText = element.textContent || element.value || element.getAttribute('data-plan');
    //       if (planText) return planText.trim();
    //     }
    //   }
      
    //   // Default to one-time purchase
    //   return 'One-time Purchase';
    // }

    // Function to sync sticky bar with main button
    function syncStickyBar() {
      if (stickyBarVariantDescription && masterSelect && masterSelect.selectedOptions.length) {
        var variantDescription = masterSelect.selectedOptions[0].getAttribute('data-sticky-variant-description') || '';
        stickyBarVariantDescription.textContent = variantDescription;
        stickyBarVariantDescription.hidden = !variantDescription;
      }

      if (stickyBarPrice && mainButtonText) {
        var mainPriceMatch = mainButtonText.textContent.match(/ - (.+)$/);
        if (mainPriceMatch) {
          stickyBarPrice.textContent = mainPriceMatch[1];
        }
      }
      
      // Update plan type text
      // if (stickyBarPlanText) {
      //   stickyBarPlanText.textContent = getCurrentPlanType();
      // }
      
      if (addToCartButton.disabled) {
        stickyBarButton.disabled = true;
      } else {
        stickyBarButton.disabled = false;
      }
    }

    // Function to toggle sticky bar
    function toggleStickyBar() {
      var buttonIsVisible = isOriginalPositionVisible();
      var shouldShowSticky = !buttonIsVisible;
      
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
 
      
      if (buttonIsVisible && isBarVisible) {
        stickyBar.classList.remove('show');
        isBarVisible = false;

      } else if (!buttonIsVisible && !isBarVisible) {
        stickyBar.classList.add('show');
        isBarVisible = true;
        syncStickyBar();
       
      }
    }

    // Handle sticky bar button click
    stickyBarButton.addEventListener('click', function() {
      var formId = this.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      if (form) {
        // Trigger the main add to cart button click
        addToCartButton.click();
      }
    });

    // Handle change link click - scroll to plan selection area
    if (stickyBarChangeLink) {
      stickyBarChangeLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Try to find the plan selection area (Loop widget or subscription options)
        var planSelectionElement = null;
        
        // Look for Loop subscription widget
        var loopWidget = document.querySelector('.loop-subscription-container, .loop-widget, [data-loop-widget]');
        if (loopWidget) {
          planSelectionElement = loopWidget;
        }
        
        // Look for other subscription selectors
        if (!planSelectionElement) {
          var subscriptionArea = document.querySelector('.subscription-options, .plan-selection, .product-form');
          if (subscriptionArea) {
            planSelectionElement = subscriptionArea;
          }
        }
        
        // Fallback to the main product form
        if (!planSelectionElement) {
          planSelectionElement = productForm;
        }
        
        // Scroll to the element
        if (planSelectionElement) {
          var elementTop = planSelectionElement.getBoundingClientRect().top + window.pageYOffset;
          var offset = 100; // Add some offset from top
          
          window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth'
          });
          
          console.log('Scrolling to plan selection area');
        }
      });
    }

    // Throttled scroll handler
    var scrollTimeout;
    function handleScroll() {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(function() {
        toggleStickyBar();
        scrollTimeout = null;
      }, 16);
    }

    // Set up observers for button state changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || 
            (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
          syncStickyBar();
        }
      });
    });

    // Observe main button text changes
    if (mainButtonText) {
      observer.observe(mainButtonText, { childList: true, subtree: true });
    }
    if (addToCartButton) {
      observer.observe(addToCartButton, { attributes: true, attributeFilter: ['disabled'] });
    }
    if (masterSelect) {
      masterSelect.addEventListener('change', syncStickyBar);
    }

    // Ensure sticky bar starts hidden
    stickyBar.classList.remove('show');
    isBarVisible = false;
    
    // Initialize original position after a short delay
    setTimeout(function() {
      originalPosition = getOriginalPosition();
      toggleStickyBar();
    }, 500);

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Handle window resize
    window.addEventListener('resize', function() {
      if (window.innerWidth > 768) {
        stickyBar.classList.remove('show');
        isBarVisible = false;
      } else {
        // Recalculate original position on resize
        setTimeout(function() {
          originalPosition = getOriginalPosition();
          toggleStickyBar();
        }, 100);
      }
    });
  }

  // Initialize
  initStickyAddToCartBar();
});

// load Gorgias chat when page url includes #livechat
function checkGorgiasChat() {
  if (window.location.hash === '#livechat' && window.GorgiasChat) {
    window.GorgiasChat.open();
  }
}
window.addEventListener('hashchange', checkGorgiasChat);
document.addEventListener('DOMContentLoaded', checkGorgiasChat);
